import styled from 'styled-components';

export const Container = styled.div`
  max-height: 900px;
  overflow: auto;
  padding: 10px 0;
`;
